import API from "..";
import { checkAPIResponse } from "../helpers";

export default class BlendFacility {
  /**
   * The BlendFacility dimension table for M3
   * @param {String} blendFacilityName The full name of the BlendFacility
   * @param {bool} isActive The IsActive for the BlendFacility
   * @param {String} siteName The siteName for the BlendFacility
   * @param {double} preparationThresholdPercent The PreparationThresholdPercent for the BlendFacility
   * @param {String} primaryContactEmail The PrimaryContactEmail for the BlendFacility
   * @param {bool} isExternalBlendFacility The IsExternalBlendFacility for the BlendFacility
   * @param {String} createdByEmail The CreatedByEmail for the BlendFacility
   * @param {Datetime} createdDate The CreatedDate for the BlendFacility
   * @param {String} lastModifiedByEmail The LastModifiedByEmail for the BlendFacility
   * @param {Datetime} lastModifiedDate The LastModifiedDate for the BlendFacility
   */

  constructor({
    blendFacilityName,
    isActive,
    siteName,
    preparationThresholdPercent,
    primaryContactEmail,
    isExternalBlendFacility,
    createdByEmail,
    createdDate,
    lastModifiedByEmail,
    lastModifiedDate
  }) 
    
  {
    this.blendFacilityName = blendFacilityName;
    this.isActive = isActive;
    this.siteName = siteName;
    this.preparationThresholdPercent = preparationThresholdPercent;
    this.primaryContactEmail = primaryContactEmail;
    this.isExternalBlendFacility = isExternalBlendFacility;
    this.createdByEmail = createdByEmail;
    this.createdDate = createdDate;
    this.lastModifiedByEmail = lastModifiedByEmail;
    this.lastModifiedDate = lastModifiedDate;
    this.blendFacilityNameToDropdown = isExternalBlendFacility ? `EXT - ${blendFacilityName}` : blendFacilityName;
  }

  static async getAllFacilities() {
    const api = await API();
    const { data } = await api.get(`/blendFacility`);
    return data.result ? data.result.map((d) => new BlendFacility(d)) : [];
  }
  
  static async getAllActive() {
    const api = await API();
    const { data } = await api.get(`/blendFacility`);
    return data.result ? data.result.filter((x) => x.isActive).map((d) => new BlendFacility(d)) : [];
  }

  static async get(name) {
    const api = await API();
    const { data } = await api.get(`blendFacility/${name}`);
    return data.result ?  new BlendFacility(data.result) : null;
  }

  static async add(info) {
    const api = await API();
    const response = await api.post(`/blendFacility`, info);
    checkAPIResponse(response);
    return new BlendFacility(response.data.result);
  }

  static async update(name, info) {
    const api = await API();
    const response = await api.put(`/blendFacility/${name}`, info);
    checkAPIResponse(response);
    return new BlendFacility(response.data.result);
  }
}
